import PropTypes from "prop-types";
import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  Platform,
  UIManager,
  ActivityIndicator,
  Animated,
  Keyboard,
} from "react-native";
import * as RootNavigation from "app/utils/RootNavigation.js";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import { styleSheet, WIDTH } from "app/utils/styleSheet";
import DatePicker from "app/components/DatePicker";
import ValueListItem from "app/components/ValueListItem";
import colorHelpers from "app/utils/colorHelpers";

import Icon from "app/components/Icon";
import TextInput from "app/components/TextInput";

import SwipeableItem from "react-native-swipeable-item";

import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";

import store from "app/redux/store";

const isAndroid = Platform.OS === "android";
if (isAndroid && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

import { StyleContext } from "app/contexts/Style";

export default class ValueComposer extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      ...this.initialState(props.value),
      confirmed: false,
      confirmAnim: new Animated.Value(0),
    };
  }

  runConfirmationAnim = () => {
    Animated.spring(this.state.confirmAnim, {
      toValue: 1,
      // duration: 400,
      friction: 7,
      useNativeDriver: !ENV.WEB,
    }).start();
  };

  initialState = (value = null) => {
    if (!value) value = this.props.value;
    return {
      value: {
        text: "",
        color: "",
        icon: "",
        // parent_ids: [],
        id: value.id,
        parent_ids: value.parent_ids,
        // parents: [],
        // child_ids: [],
        // children: [],
        progress_at: [],
      },
      parents: [],
      children: [],
      composing: true,
      nameQuery: "",
      parentQuery: "",
      childQuery: "",
      showMore: false,
      showIconSelector: false,
      showColorSelector: false,
      formIsDirty: false,
    };
  };

  render() {
    let {
      value,
      parentQuery,
      childQuery,
      nameQuery,
      showMore,
      composing,
      showIconSelector,
      showColorSelector,
      formIsDirty,
      confirmAnim,
      confirmed,
    } = this.state;

    let fetching = false;

    let color = valueHelpers.colorAsHex(value.color, this.context.colorScheme);
    // let darkenBy = 1;
    // let backgroundColor = colorHelpers.modifyHex(color, darkenBy);
    // let backgroundColor = color;
    // let backgroundColor = this.context.colors.fill;

    let valueColor =
      valueHelpers.colorAsHex(value.color, this.context.colorScheme) ||
      this.context.colors.fill;

    let placeholderColor = colorHelpers.hexToRgbaString(
      !value.color
        ? this.context.colors.foreground
        : this.context.colors.lightForeground,
      0.5
    );

    // let { color: iconColor, opacity } = valueHelpers.iconColor(
    //   value,
    //   color,
    //   this.context.colorScheme
    // );
    // iconColor = colorHelpers.hexToRgbaString(iconColor, opacity);
    let iconColor = color;
    let backgroundColor = !!value.color
      ? colorHelpers.modifyHex(valueColor, this.context.colors.darkenBy)
      : this.context.colors.fill;

    return (
      <View style={this.styles().wrapper}>
        {confirmed && (
          <Animated.View
            style={[
              { transform: [{ scale: confirmAnim }] },
              this.styles().confirmationBorder,
              { borderColor: backgroundColor },
            ]}
          />
        )}
        <View style={[this.styles().innerWrapper, { backgroundColor }]}>
          <View style={[this.styles().wrapperRow]}>
            <View style={{ flexDirection: "row" }}>
              {this.renderIcon(iconColor, placeholderColor)}

              <TextInput
                // autoFocus
                inputRef={(c) => (this.input = c)}
                // multiline
                // autoHeight
                placeholder={this.props.placeholder}
                placeholderTextColor={placeholderColor}
                // containerStyle={{borderWidth: 1, borderColor: 'white', flex: 1}}
                value={value.text}
                // extraStyle={this.styles().bigInput}
                // data={suggestions}
                onChangeText={(text) => {
                  this.setState({ nameQuery: text });
                  this.onChangeValue("text", text);
                }}
                onEnter={() => {
                  this.setConfirmationTimeout(0);
                }}
                onBlur={() => {
                  this.setConfirmationTimeout(0);
                }}
                style={[
                  this.styles().input,
                  {
                    color: !!value.color
                      ? this.context.colors.lightForeground
                      : this.context.colors.foreground,
                  },
                ]}
              />
              {this.renderColorSelector(placeholderColor, iconColor)}
            </View>
          </View>
          <View>
            {showColorSelector
              ? this.renderColorOptions()
              : showIconSelector
              ? this.renderIconOptions(iconColor)
              : null}
          </View>
        </View>
      </View>
    );
  }

  renderIcon = (iconColor, placeholderColor) => {
    let { value, showIconSelector } = this.state;
    let iconName = valueHelpers.getIcon(value);
    return (
      <TouchableOpacity
        onPress={() => {
          this.setState({
            showIconSelector: !showIconSelector,
            showColorSelector: false,
          });
          Keyboard.dismiss();
        }}
      >
        <View style={[this.styles().colorDot]}>
          {!value.icon ? (
            <MaterialCommunityIcons
              name="selection-ellipse-arrow-inside"
              name="selection-ellipse"
              name="shape-plus"
              color={placeholderColor}
              size={this.context.sizes.itemHeight}
            />
          ) : (
            <Icon
              name={iconName}
              color={iconColor}
              //color={emptyColor}
              // style={{ opacity }}
              size={this.context.sizes.itemHeight}
            />
          )}
        </View>
      </TouchableOpacity>
    );
  };

  renderColorSelector = (placeholderColor, iconColor = null) => {
    let { value, showColorSelector } = this.state;
    //<View style={{ width: this.context.sizes.itemHeight * 2 }}>
    return (
      <View>
        <TouchableOpacity
          onPress={() => {
            this.setState({
              showColorSelector: !showColorSelector,
              showIconSelector: false,
            });
            Keyboard.dismiss();
          }}
        >
          {!value.color ? (
            <View style={[this.styles().colorDot]}>
              <Ionicons
                name="color-fill"
                size={this.context.sizes.itemHeight}
                size={20}
                color={placeholderColor}
              />
            </View>
          ) : (
            <View
              style={[
                this.styles().colorDot,
                { borderWidth: 2, borderColor: iconColor, padding: 4 },
              ]}
            >
              <View
                style={[
                  this.styles().innerColorDot,
                  { backgroundColor: iconColor },
                ]}
              />
            </View>
          )}
        </TouchableOpacity>
      </View>
    );
  };

  renderColorOptions = () => {
    let { value } = this.state;
    return (
      <ScrollView style={this.styles().selectorWrapper}>
        <View style={[this.styles().selectorRow, { alignSelf: "flex-end" }]}>
          {valueHelpers.colorOptions().map((c, i) => {
            let selected = value.color == c;
            let color = valueHelpers.colorAsHex(c, this.context.colorScheme);
            return (
              <TouchableOpacity
                key={i}
                style={[
                  this.styles().selectable,
                  selected && { borderWidth: 1, borderColor: color },
                ]}
                onPress={() => this.onChangeValue("color", c)}
              >
                <View
                  style={[
                    this.styles().colorDot,
                    {
                      backgroundColor: color,
                    },
                  ]}
                />
              </TouchableOpacity>
            );
          })}
        </View>
      </ScrollView>
    );
  };

  renderIconOptions = (iconColor) => {
    let { value } = this.state;
    return (
      <ScrollView style={this.styles().selectorWrapper}>
        <View style={[this.styles().selectorRow, { alignSelf: "flex-start" }]}>
          {iconHelpers.iconOptions().map((icn, i) => {
            let selected = value.icon == icn;
            if (["select", "none"].includes(icn)) return null;
            return (
              <TouchableOpacity
                key={i}
                style={[
                  this.styles().selectable,
                  selected && { borderWidth: 1, borderColor: iconColor },
                ]}
                onPress={() =>
                  this.onChangeValue(
                    "icon",
                    ["select", "none"].includes(icn) ? "" : icn
                  )
                }
              >
                <Icon name={icn} color={iconColor} />
              </TouchableOpacity>
            );
          })}
        </View>
      </ScrollView>
    );
  };

  setConfirmationTimeout = async (waitFor = 1000) => {
    if (!!this.confirmationTimeout) clearTimeout(this.confirmationTimeout);
    this.confirmationTimeout = setTimeout(async () => {
      if (this.validate()) {
        this.props.setConfirmed(true);
        await this.setState({ confirmed: true });
        this.runConfirmationAnim();
      } else {
        this.setState({ confirmed: false, confirmAnim: new Animated.Value(0) });
        this.props.setConfirmed(false);
      }
    }, waitFor);
  };

  validate = () => {
    let { value } = this.state;
    let valid = true;
    if (!value.text?.length) valid = false;
    else if (!value.icon?.length) valid = false;
    else if (!value.color?.length) valid = false;
    return valid;
  };

  onChangeValue = (key, val) => {
    let { value } = this.state;
    value[key] = val;
    this.setState({
      value,
      showIconSelector: false,
      showColorSelector: false,
      formIsDirty: true,
    });
    let waitFor = key == "text" ? 1000 : 100;
    if (!value.text?.length) waitFor = 0;
    if (ENV.WEB || key != "text") {
      this.setConfirmationTimeout(waitFor);
    }
    this.props.onUpdateValue(value);
  };

  styles = () => ({
    wrapper: {
      width: this.props.width,
      alignSelf: "flex-start",
      maxWidth: this.context.sizes.WIDTH,
    },
    innerWrapper: {
      // alignItems: "space-between",
      borderRadius: this.context.sizes.borderRadius,
      paddingHorizontal: this.context.sizes.large,
      padding: this.context.sizes.base,
    },
    wrapperRow: {
      flexDirection: "row",
      alignItems: "center",
      // justifyContent: "space-between",
    },
    input: {
      // ...styleSheet.input,
      flex: 1,
      width: 230,
      maxWidth: this.props.width - this.context.sizes.itemHeight * 4,
      marginHorizontal: this.context.sizes.default,
    },
    topButtonWrapper: {
      marginRight: this.context.sizes.large,
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    buttonIcon: {
      fontSize: this.context.sizes.itemHeight,
      marginLeft: this.context.sizes.large,
    },
    buttonWrapper: {
      zIndex: -1,
      flexDirection: "row",
      justifyContent: "space-between",
      marginLeft: this.context.sizes.large,
    },
    selectorWrapper: {
      marginTop: this.context.sizes.base,
      width: ENV.WEB
        ? this.props.width - 40
        : this.props.width - this.context.sizes.large * 3,
      maxWidth: this.props.width - this.context.sizes.large * 3,
      alignSelf: "stretch",
      maxHeight: 225,
    },
    selectorRow: {
      flexDirection: "row",
      flexWrap: "wrap",
    },
    colorDot: {
      width: this.context.sizes.itemHeight,
      height: this.context.sizes.itemHeight,
      borderRadius: this.context.sizes.itemHeight / 2,
      justifyContent: "center",
      alignItems: "center",
    },
    innerColorDot: {
      width: this.context.sizes.itemHeight - 8,
      height: this.context.sizes.itemHeight - 8,
      borderRadius: this.context.sizes.itemHeight - 8 / 2,
      justifyContent: "centier",
      alignItems: "center",
    },

    underlayRow: {
      // flexDirection: "row",
      // flex: 1,
      // alignItems: "center",
      // justifyContent: "space-around",
      // // padding: 15
    },
    underlayRight: {
      // flex: 1,
      // // backgroundColor: "teal",
      // justifyContent: "flex-start"
    },

    suggestionWrapper: {
      padding: this.context.sizes.base,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    icon: {
      fontSize: this.context.sizes.itemHeight,
    },
    selectable: {
      width: this.context.sizes.itemHeight + this.context.sizes.small * 2,
      height: this.context.sizes.itemHeight + this.context.sizes.small * 2,
      justifyContent: "center",
      alignItems: "center",
      // backgroundColor: this.context.colors.fill,
      borderColor: this.context.colors.fill,
      // borderWidth: 1,
      borderRadius: this.context.sizes.small,
      margin: this.context.sizes.small,
      padding: this.context.sizes.small,
    },
    confirmationBorder: {
      zIndex: -1,
      position: "absolute",
      backgroundColor: this.context.colors.empty,
      top: -4,
      right: -4,
      left: -4,
      bottom: -4,
      borderWidth: 2,
      borderRadius: this.context.sizes.borderRadius + 3,
    },
  });
}
